module.exports = __webpack_public_path__ + "static/media/profile-image.a6b90a10.png";